var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { asEffect, useMachine } from '@xstate/react';
import { noop } from 'lodash';
import { useRef, useState } from 'react';
import { v4 } from 'uuid';
import { createFlowMachine } from './createFlowMachine';
export var useCreateFlow = function (_a) {
    var onSave = _a.onSave, focusOnInit = _a.focusOnInit, _b = _a.onRepeat, onRepeat = _b === void 0 ? noop : _b;
    var focusRef = useRef(null);
    var _c = __read(useState(v4()), 2), inputKey = _c[0], setInputKey = _c[1];
    var _d = __read(useState(null), 2), savingFrom = _d[0], setSavingFrom = _d[1];
    var _e = __read(useMachine(createFlowMachine({ onSave: onSave, focusOnInit: focusOnInit }), {
        actions: {
            resetInputKey: function () { return setInputKey(v4()); },
            setFocus: asEffect(function () { var _a; return (_a = focusRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }),
            onRepeat: onRepeat,
        },
        devTools: true,
    }), 2), state = _e[0], send = _e[1];
    var cancel = function () {
        send('CANCEL');
    };
    var isSavingFromInput = savingFrom === 'input' && state.matches('saving');
    if (state.matches('input') || isSavingFromInput) {
        var review = function (item) {
            send({ type: 'REVIEW', item: item });
        };
        var save = function (item) {
            setSavingFrom('input');
            send({ type: 'SAVE_FROM_INPUT', item: item });
        };
        var item = state.context.item;
        var saveError = state.matches('input')
            ? state.context.saveError
            : undefined;
        return {
            step: 'input',
            focusRef: focusRef,
            cancel: cancel,
            review: review,
            item: item,
            saveError: saveError,
            key: inputKey,
            save: save,
            isSaving: state.matches('saving'),
        };
    }
    var isSavingFromReview = savingFrom === 'review' && state.matches('saving');
    if (state.matches('review') || isSavingFromReview) {
        var item = state.context.item;
        var edit = function () {
            send('EDIT');
        };
        var save = function () {
            setSavingFrom('review');
            send('SAVE');
        };
        return {
            step: 'review',
            cancel: cancel,
            item: item,
            focusRef: focusRef,
            edit: edit,
            save: save,
            isSaving: state.matches('saving'),
        };
    }
    if (state.matches('confirm')) {
        var item = state.context.item;
        var repeat = function () {
            send('REPEAT');
        };
        return {
            step: 'confirm',
            item: item,
            repeat: repeat,
            focusRef: focusRef,
        };
    }
    throw new Error('createFlowMachine is in an invalid state');
};
//# sourceMappingURL=useCreateFlow.js.map